import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { TReviewPerson } from '@onesource/schemas';
import { getMediaUrl } from '@onesource/services';
import { FC } from 'react';

/** Admins' column: whose student this is, or a warning when nobody's. Hidden on phones. */
export const ReviewTeacherCell: FC<{ teacher: TReviewPerson | null }> = ({ teacher }) => (
  <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 1, width: 180, flexShrink: 0 }}>
    {teacher ? (
      <>
        <Avatar
          src={teacher.avatar ? getMediaUrl(teacher.avatar) : undefined}
          sx={{ width: 24, height: 24, fontSize: '0.75rem' }}
        >
          {teacher.name.charAt(0).toUpperCase()}
        </Avatar>
        <Typography variant="caption" color="text.secondary" noWrap>
          {teacher.name}
        </Typography>
      </>
    ) : (
      <Typography variant="caption" sx={{ color: '#b45309', fontWeight: 600 }}>
        No teacher assigned
      </Typography>
    )}
  </Box>
);
